<div class="record-buttons">
  <button
    class="record-buttons__item record-buttons-repeat"
    [class.record-buttons-repeat--active]="repeat"
    (click)="onRepeatButtonClick()"
    [disabled]="repeatButtonIsDisabled"
    title="Loop Playback"
    i18n-title
  >
    <span class="icon-repeat"></span>
  </button>

  <button
    class="record-buttons__item record-buttons-playback"
    (click)="onPlaybackButtonClick()"
    [disabled]="playbackButtonIsDisabled"
    title="Play the record"
    i18n-title
  >
    <span
      [class.icon-stop]="playback"
      [class.icon-play]="false === playback"
    ></span>
  </button>

  <button
    class="record-buttons__item record-buttons-recording"
    [class.record-buttons-recording--active]="recording"
    (click)="onRecordingButtonClick()"
    [disabled]="recordingButtonIsDisabled"
    title="Recording"
    i18n-title
  >
    <span class="record-buttons-recording__icon icon-microphone"></span>
  </button>

  <button
    class="record-buttons__item record-buttons__item--undo"
    (click)="onUndoButtonClick()"
    [disabled]="undoButtonDisabled"
    title="Undo the previous action"
    i18n-title
  >
    <span class="icon-undo"></span>
  </button>

  <button
    class="record-buttons__item record-buttons__item--redo"
    (click)="onRedoButtonClick()"
    [disabled]="redoButtonDisabled"
    title="Redo the previous action"
    i18n-title
  >
    <span class="icon-redo"></span>
  </button>
</div>



// WEBPACK FOOTER //
// ./src/app/rec/components/record-buttons/record-buttons.component.html